import { gql } from '@apollo/client';

export const CreateExportOrganizationUsersRequest = gql`
  mutation CreateExportOrganizationUsersRequest(
    $organizationCode: String!
    $personIdentifiers: [String]
    $columns: [OrganizationExportedColumn!]
    $textSearch: String
  ) {
    createExportOrganizationUsersRequest(
      organizationCode: $organizationCode
      personIdentifiers: $personIdentifiers
      columns: $columns
      textSearch: $textSearch
    )
  }
`;

export enum OrgExportColumnId {
  LastName = 'LASTNAME',
  FirstName = 'FIRSTNAME',
  Email = 'EMAIL',
  CreationDate = 'CREATIONDATE',
  Status = 'STATUS',
  Domain = 'DOMAIN',
  AccountCode = 'ACCOUNTCODE',
  AccountLabel = 'ACCOUNTLABEL',
  DirectoryLabel = 'DIRECTORYLABEL',
  AccountAdministratorsCode = 'ACCOUNTADMINISTRATORSCODE',
  AccountAdministratorsLabel = 'ACCOUNTADMINISTRATORSLABEL'
}

export const ORG_COLUMNS_ORDER = [
  OrgExportColumnId.LastName,
  OrgExportColumnId.FirstName,
  OrgExportColumnId.Email,
  OrgExportColumnId.CreationDate,
  OrgExportColumnId.Status,
  OrgExportColumnId.Domain,
  OrgExportColumnId.AccountCode,
  OrgExportColumnId.AccountLabel,
  OrgExportColumnId.AccountAdministratorsCode,
  OrgExportColumnId.AccountAdministratorsLabel,
  OrgExportColumnId.DirectoryLabel
];
